import { render, staticRenderFns } from "./ShopSelect.vue?vue&type=template&id=c18b267c"
import script from "./ShopSelect.vue?vue&type=script&lang=js"
export * from "./ShopSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c18b267c')) {
      api.createRecord('c18b267c', component.options)
    } else {
      api.reload('c18b267c', component.options)
    }
    module.hot.accept("./ShopSelect.vue?vue&type=template&id=c18b267c", function () {
      api.rerender('c18b267c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShopSelect.vue"
export default component.exports